'use client';

import { getPartnerLogos } from '@/lib/partnerLogos';

export default function LogoMarquee({ className = '' }: { className?: string }) {
  const merged = getPartnerLogos();

  // Duplicate once to create a seamless loop
  const items = [...merged, ...merged];

  return (
    <div
      className={`relative w-full overflow-hidden ${className}`}
      style={{
        // Soft fade at both edges so logos ease in/out instead of being
        // sliced abruptly at the screen edge (especially noticeable on mobile).
        WebkitMaskImage:
          'linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)',
        maskImage:
          'linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)',
      }}
    >
      <div className="marquee flex w-max items-center gap-6 pr-6 md:gap-8 md:pr-8">
        {items.map((logo, i) => (
          <div
            key={`${logo.src}-${i}`}
            className="shrink-0 opacity-80 hover:opacity-100 transition-opacity h-8 w-[104px] md:h-11 md:w-[140px] flex items-center justify-center"
          >
            <img
              src={logo.src}
              alt={logo.alt}
              loading="lazy"
              decoding="async"
              style={{
                height: '100%',
                width: 'auto',
                objectFit: 'contain',
                backgroundColor: 'transparent',
              }}
            />
          </div>
        ))}
      </div>

      <style jsx>{`
        .marquee {
          animation: scrollX 28s linear infinite;
        }
        @keyframes scrollX {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
}
